import React, { useEffect,useContext, useState } from "react";
import { AppContext, UserContext } from "../../../AppContextProvider";
import { useNavigate, useParams } from "react-router-dom";
import { useFetch } from "../../api/FetchApiData";
import { MediaUrl } from "../../utils/Media";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import Select from "react-select";
import { QRCodeSVG } from "qrcode.react";
import { SaleComment, TicketView, TicketViewPopUp } from "../sales/Sale";
import { Rating } from "react-simple-star-rating";
import home_icon from '../../map/icons/home.png';
import store_icon from '../../map/icons/shop.png';

if (isMobile)
    import('./order_mob.css').then(() => {});
else
    import('./order.css').then(() => {});

export default function Order()
{
    const [order,setOrder] = useState({payments:[],owned:false,customer:{label:''},address:{label:''},articles:[],historic:[],status:'en attente',total_price:0,customer_ticket:''})
    const fetchData = useFetch();
    const [UserState,setUserState] = useContext(UserContext);
    const {id} = useParams();
    const [locations,setLocations] = useState([null,null]);
    const navigator = useNavigate();
    
    useEffect(()=>{
        if(!UserState.auth)
            navigator('/');
    },[UserState.auth])

    const LocationSelectOption = (location = {label : 'Chez Maman Cheikh', ville:'Ngnadomboeni Hamahamer'},is_location=true)=>{
        if(is_location)
        {
            let imgsrc = home_icon;
            if(location.type==='partner_point')
                imgsrc = store_icon;
            return(
                <div key={location.label} style={{fontSize:'small'}}>
                    <img src={imgsrc} style={{width:'25px',height:'25px',marginRight:'5px',verticalAlign:'middle',borderRadius:'15px',display:'inline-block'}} />
                    <div style={{display:'inline-block',width:'82%',verticalAlign:'middle',textAlign:'center'}}>
                        <label>{location.label}</label><br/>
                        <span style={{color:'rgb(120,120,120)'}}>{location.display_name}</span>
                    </div>
                </div>);
        }
        else
        {
            return(
            <div key={location.title} style={{fontSize:'small'}}>
                <img src={MediaUrl(location.logo.image)} style={{width:'30px',height:'30px',verticalAlign:'middle',borderRadius:'15px',display:'inline-block'}} />
                <div style={{display:'inline-block',width:'82%',verticalAlign:'middle',textAlign:'center'}}>
                <label>{location.title}</label><br/>
                    <span style={{color:'rgb(120,120,120)'}}>{location.phone}</span>
                </div>
            </div>);
        }
    }

    const PartnerOption = (deliver)=>{
            if(deliver === null || deliver === undefined)
                return;
            return({ label:
                <div key={deliver.title} style={{fontSize:'small'}}>
                    <div style={{display:'inline-block',verticalAlign:'middle',maxWidth:'50px'}}>
                        <div style={{margin:'auto',marginBottom:'-6px'}}>
                            <img src={MediaUrl(deliver.logo.image)} style={{margin:'auto',width:'28px',height:'28px',borderRadius:'15px'}} />
                        </div>
                        <Rating st initialValue={2.5} size={8} style={{}} />
                    </div>
                    <div style={{display:'inline-block',width:'77%',verticalAlign:'middle',textAlign:'center'}}>
                        <label>{deliver.title}</label><br/>
                        <label style={{color:'gray',fontSize:'xx-small'}}>{deliver.phone}</label>
                    </div>
                </div>});
    }

    useEffect(()=>{
        if(!UserState.auth)
            navigator("/");
        let user_id = UserState.id;
        if(user_id === undefined || user_id === null)
            user_id = 'self';
        if(!!id)
            fetchData.GetData(`user/order/${user_id}/${id}/1/`).then((result)=>{
                if(result.result)
                {
                    setOrder({...result.order});
                    if(!!result.order.address)
                        setLocations([{label:LocationSelectOption(result.order.address,true)}   ])
                    
                }
            });
    },[])

    const Promo = (art)=>
    {
        if(!!art.promo)
            return (<>
                <span> -{art.promo[0].reduction}% ({art.promo[0].title})</span>
            </>)
    }

    const _status = (status)=>{
        if(typeof(status)===typeof('status'))
            return status
        else
            return status.status
    }

    const Status = ()=>{
        let text = ''
        if(_status(order.status)==='en attente')
            text =  <div style={{textAlign:'center',width:'100%'}}>
                        <span style={{maxWidth:'90%',display:'block',margin:'auto',margin:'5px'}}>Vous devez allez confirmer votre commande chez un de nos partenaires.<br/>
                        <span style={{fontWeight:'bold'}}>Temps restant : 3h 48min</span></span>
                        { order.owned && <input type="button" value={'Trouver un partenaire'} style={{height:'40px',
                            backgroundColor:'lightblue',
                            borderRadius:'5px',
                            border:'none',
                            margin:'5px 5px 10px 5px',
                            padding:'3px 20px 3px 20px',
                            color:'black',width:'60%'}} />}
                    </div>;
        else if(_status(order.status)==='confirmé')
            text = <span>Expedition en cours de préparation</span>;
        else if(_status(order.status)==='expedié')
            text = <span style={{maxWidth:'90%',display:'block',margin:'auto',margin:'0px 0px 5px 0px'}}>Votre colis est entre les mains du transporteur et vous sera livré bientôt</span>;
        else if(_status(order.status)==='livré')
            text = <span>Commande executé, merci pour votre confiance.</span>;
        else
            text = <span>Merci pour votre commande</span>;
        
        return(
        <>
            <label className="order-status" style={{fontWeight:'bold'}}>{_status(order.status).toUpperCase()}</label><br/>
                <label className="order-content-info" style={{color:'gray'}}>
                    {text}
                </label>
        </>)
    }

    const TotalPayments = ()=>{
        let total = 0;
        order.payments.map((paie)=>{
            total = total + Number(paie.mount);
        });
        let color = 'green';
        if(total<order.total_price)
            color = 'red';

        return <label><b><span style={{color:color}}>{total} €</span> /{order.total_price}€</b></label>;
    }

    return(<div className="order">
        <div className="order-div">
            <h4 className="order-title">COMMANDE</h4>
            <div className="order-content">
                <div style={{display:'inline-block',verticalAlign:'middle',backgroundColor:'green',paddingTop:'10px'}}>
                    <label>{order.order_number}</label>
                    <label style={{display:'block',color:'gray',marginBottom:'10px'}}>{order.date}</label>
                </div>
                {/*
                <div className="p-4 bg-white shadow-lg rounded">
                    { order.owned && <QRCodeSVG value={order.customer_ticket} size={100} />}
                </div>
                */}
                <div style={{display:'inline-block',width:'30%',verticalAlign:'Top'}}>
                    <TicketViewPopUp order={order} data_ticket={order.customer_ticket} enable_download={true} is_delivry={false} />
                </div>
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">STATUS</h4>
            <div className="order-content">
                {Status()}
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">ARTICLES</h4>
            <div className="order-content">
            {order.articles.map((art,index)=>{
                let borderBottom = '1px solid lightgray';
                if(index===order.articles.length-1)
                    borderBottom = 'none'
                return(
                <div style={{borderBottom:borderBottom}} className="order-article" onClick={e=>{navigator(`/product/${art.article_id}`)}} key={index}>
                    <img src={MediaUrl(art.image)} className="order-article-img"/>
                    <div className="order-article-info" >
                        <label className='order-article-title'>{art.title}</label><br/>
                        <label className="order-article-text" style={{color:'gray'}}>
                            <span className="order-article-item" style={{marginRight:'20px'}}>Quantité : {art.quantity}</span>
                            <span style={{marginRight:'10px'}}>Prix : {art.price}</span>
                            {Promo(art)}
                        </label>
                    </div>
                    <div className="order-delivery-div" style={{marginTop:'10px'}}>
                        <label className="order-delivery-label">Livreur : </label>
                        <div className="order-select-location">
                            <Select 
                                isDisabled
                                value={PartnerOption(art.deliver)}
                                options={[PartnerOption(art.deliver)]}
                            />
                        </div>
                </div>
                </div>)
            })}
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">LIVRAISON</h4>
            <div className="order-content">
                <div className="order-delivery-div" style={{marginTop:'10px'}}>
                    <label className="order-delivery-label"  >Addresse : </label>
                    <div className="order-select-location" >
                        <Select 
                            isDisabled
                            value={locations[0]}
                        />
                    </div>
                </div>
                <div className="order-delivery-div" style={{marginTop:'10px'}}>
                    <BrowserView className="order-delivery-label">
                        <label>Commentaires :</label>
                    </BrowserView>
                    <textarea disabled={order.owned} className="order-select-location" style={{minHeight:'80px',textAlign:'center',border:'1px solid lightgray',borderRadius:'5px'}} placeholder="Indiquez des precisions au livreur" />
                </div>
                <div className="order-delivery-div" style={{marginTop:'10px',verticalAlign:'middle',display:'flex',flexDirection:'row'}}>
                    <label className="order-delivery-label" style={{display:'inline-block'}}>Prix :</label>
                    <MobileView className="order-select-location" style={{verticalAlign:'middle',display:'inline-block',marginLeft:'10px',width:'fit-content'}}><span style={{fontWeight:'bold'}}>{order.delivery_price} €</span></MobileView>
                    <BrowserView className="order-select-location">
                        <label style={{textAlign:'left'}}>{order.delivery_price} €</label>
                    </BrowserView>
                </div>
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">PAIEMENTS</h4>
            <div className="order-content">
                {order.payments.map((payment,index)=>{
                    let borderBottom = '1px solid lightgray';
                    if(index===order.payments.length-1)
                        borderBottom = 'none'
                    return(
                    <div style={{borderBottom:borderBottom, padding:'10px 0px 10px 0px',borderRadius:'5px',margin:'5px'}}>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>Date de paiement : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{payment.date}</label>
                        </div>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>Mode de paiement : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{payment.mode}</label>
                        </div>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label">Montant : </label>
                            <label className="order-select-location" style={{fontWeight:'bold',fontSize:'small'}}>{payment.mount} €</label>
                        </div>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>Encaisser par : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{payment.cashier.name}</label>
                        </div>
                    </div>);
                })}
                {(order.payments.length===0)&& (<span style={{color:'gray'}}>Aucun paiement pour le moment</span>)}
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">TOTAL :</h4>
            <div className="order-content" style={{margin:'auto',marginTop:'15px',width:'70%'}}>
                {TotalPayments()}
            </div>
        </div>
        { (order.historic.length > 0) &&
            <div className="order-div">
                <BrowserView style={{display:'inline-block',width:'15%'}}>
                    <h4 className="order-title" style={{width:'100%'}}>SUIVI :</h4>
                </BrowserView>
                <MobileView>
                    <h4 className="order-title">SUIVI :</h4>
                </MobileView>
                <div className="order-content" style={{marginTop:'10px',width:'75%',margin:'auto',fontSize:'small'}}>
                    {order.historic.map((item, index)=>{
                        let border = '1px solid lightgray';
                        if(index===order.historic.length-1)
                            border = 'none'
                        return(
                            <SaleComment comment={item} editable={false} border={border} />
                        )
                    })}
                </div>
        </div>
        }
        <div style={{marginTop:'0px'}}>
            {(_status(order.status)!=='Annulee') && <input className="order-btn" type="button" value={'Annuler'} style={{backgroundColor:'#FFCBCC'}}  />}
            {order.owned && <>
                <input onClick={e=>{navigator(`/conversations/client/${order.id}/`)}} className="order-btn" type="button" value={'Messages'} style={{backgroundColor:'lightgray'}} />
                <input className="order-btn" type="button" value={'Facture'} style={{backgroundColor:'lightgray'}} />
            </>}
        </div>
    </div>); 
} 